import React from 'react';
import Select from '../../../components/ui/Select';

const FilterBar = ({
  filterDifficulty,
  filterContentType,
  sortBy,
  onDifficultyChange,
  onContentTypeChange,
  onSortChange
}) => {
  const difficultyOptions = [
    { value: 'all', label: 'All Levels' },
    { value: 'beginner', label: 'Beginner' },
    { value: 'intermediate', label: 'Intermediate' },
    { value: 'advanced', label: 'Advanced' }
  ];

  const contentTypeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'guide', label: 'Guide' },
    { value: 'tutorial', label: 'Tutorial' },
    { value: 'reference', label: 'Reference' }
  ];

  const sortOptions = [
    { value: 'relevance', label: 'Most Relevant' },
    { value: 'popular', label: 'Most Popular' },
    { value: 'recent', label: 'Recently Updated' },
    { value: 'rating', label: 'Highest Rated' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Difficulty
          </label>
          <Select
            options={difficultyOptions}
            value={filterDifficulty}
            onChange={onDifficultyChange}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Content Type
          </label>
          <Select
            options={contentTypeOptions}
            value={filterContentType}
            onChange={onContentTypeChange}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Sort By
          </label>
          <Select
            options={sortOptions}
            value={sortBy}
            onChange={onSortChange}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterBar;